import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import {
  SportingSecureParams,
  TSportingCompetitionsArticle
} from 'services/sporting/types';
import { createQueryString } from 'utils/createQueryString';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  pageNum: number;
};

export const getNearCompetitions = async (
  params: SportingSecureParams<Payload>
): Promise<TSportingCompetitionsArticle[]> => {
  const { payload } = params;

  const endpointURL = getSportingServiceURL(
    `getNearCompetitions?${createQueryString(payload)}`
  );

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, { headers });

  if (response.ok) {
    return response.json();
  } else {
    throw new UnexpectedError();
  }
};
